export const SearchCriteriaFields = {
    jobTitles: 'jobTitles',
    pastJobTitles: 'jobTitlesPast',
    locations: 'locations',
    skills: 'skills',
    specialties: 'specialties',
    companies: 'companies',
    industries: 'industries',
    schools: 'schools',
    educationLevel: 'educationLevel',
    languages: 'languages',
    maxYearsOfExperience: 'maxYearsOfExperience',
    minYearsOfExperience: 'yearsOfExperience',
    maxSeniorityLevel: 'maximalSeniority',
    minSeniorityLevel: 'minimalSeniority',
    talentInfoSearch: 'talentInfoSearch',
    booleanSearch: 'booleanSearch',
    diversity: 'diversity',
    minCompanySize: 'companySize',
    maxCompanySize: 'maxCompanySize',
    minYearsOfManagerialExperience: 'managerYearsExperience',
    maxYearsOfManagerialExperience: 'maxManagerYearsExperience',
    minAverageTenure: 'averageTenure',
    maxAverageTenure: 'maxAverageTenure',
    currentTenure: 'currentTenure',
    minAnyRelevantYearsOfExperience: 'jobTitlesAnySeniority',
    maxAnyRelevantYearsOfExperience: 'maxJobTitlesAnySeniority',
    minSameRelevantYearsOfExperience: 'jobTitlesSameSeniority',
    maxSameRelevantYearsOfExperience: 'maxJobTitlesSameSeniority',
};

export const JOB_DESCRIPTION_FIELD_KEY = 'jobDescription';
export const JOB_TITLE_FIELD_KEY = 'jobTitle';

export const SearchLookupData = {
    jobTitleStatuses: 'jobTitleStatuses',
    locationDistance: 'locationDistance',
    companySizes: 'companySizes',
    industries: 'industries',
    yearsOfExperience: 'yearsOfExperience',
    seniority: 'seniority',
    companyPeriod: 'companyPeriod',
    languagesLevel: 'languagesLevel',
    languages: 'languages',
    industriesStatuses: 'industriesStatuses',
    specialtiesStatuses: 'specialtiesStatuses',
    averageTenurePeriods: 'averageTenurePeriods',
    pastJobTitleStatuses: 'pastJobTitleStatuses',
};

export const SearchCriteriaFilterValues = {
    filter: 'filter',
    mandatory: 'mandatory',
    preferred: 'preferred',
    optional: 'optional',
};

export const SearchCriteriaFilterWeights = {
    [SearchCriteriaFilterValues.filter]: 1,
    [SearchCriteriaFilterValues.mandatory]: 0.99999,
    [SearchCriteriaFilterValues.preferred]: 0.75,
    [SearchCriteriaFilterValues.optional]: 0.5,
};

export const SearchCriteriaTypes = {
    static: 'static',
    dynamic: 'dynamic',
    semiDynamic: 'semiDynamic',
    minMaxStatic: 'minMaxStatic',
    freeText: 'freeText',
};

export const ADDITIONAL_CRITERION_VALUES = {
    EXCLUDED: '-2',
    REVERTED_EXCLUDED: '2',
    NATIVE: '1',
    EXCELLENT: '2',
    ALL_NOT: '-1',
    BASIC: '3',
};

export const PopupFeedbackItemTypes = {
    industry: SearchCriteriaFields.industries,
    company: SearchCriteriaFields.companies,
    currentJobTitle: SearchCriteriaFields.jobTitles,
    pastJobTitle: SearchCriteriaFields.pastJobTitles,
    skill: SearchCriteriaFields.skills,
    skills: SearchCriteriaFields.skills,
    educationSchool: SearchCriteriaFields.schools,
    seniority: SearchCriteriaFields.minSeniorityLevel,
};

export const MultipleSelectionEditableCriteriaPopups = {
    location: 'location',
    relevantExperience: 'relevantExperience',
    seniority: 'seniority',
    averageTenure: 'averageTenure',
    companySize: 'companySize',
    totalExperience: 'totalExperience',
    currentTenure: 'currentTenure',
    managerialExperience: 'managerialExperience',
};

// Popups whose ratings should be merged (recommendations/insights/filterNames accumulated) into a
// single "ratings" entry instead of being replaced (like MultipleSelectionEditableCriteriaPopups) or
// pushed as a brand-new entry. Skill popups are answered one skill at a time, incrementally editing
// the very same "skills" criteria/group for the candidate - so several skill ratings within one
// Manual Selection session represent a single logical rating for that criteria, not separate ones.
export const MultipleSelectionMergeableCriteriaPopups = {
    skill: 'skill',
    skills: 'skills',
};

export const InsightIdTypes = {
    companySize: 'companySize',
    companyName: 'companyName',
    industry: 'industry',
};

export const InsightIdTypeFilterNameMap = {
    [InsightIdTypes.companyName]: [SearchCriteriaFields.companies],
    [InsightIdTypes.companySize]: [SearchCriteriaFields.minCompanySize, SearchCriteriaFields.maxCompanySize],
    [InsightIdTypes.industry]: [SearchCriteriaFields.industries],
};
